// SPEC-MIN-VERSION-SERVER-CONTROLLED-V1 (D-457) ITEM_4: 最小サポート版をサーバ(app_config)から取る。
//   強制更新の閾値をビルド焼き込みから切り離し、デプロイなしで上げ下げできるキルスイッチにする。
//   version.json の minimum_supported は読まない(DECISIONS 二: 二重ソースの食い違いを避ける)。
import { supabase } from './supabase'
import { parseVersion } from './appVersion'

// app_config.minimum_supported_version を1行取る。
//   取得失敗 / 行が無い / 値が版形式でない のいずれも null を返す(例外を投げて画面を壊さない)。
//   返り値 null = 「強制しない」。isBelowMinimum は null 安全(false)なのでそのまま渡せる。
//   DB が引けないときに強制しないのは意図した非対称(壊れた版を止め損ねる < 全端末ログイン不能)。
export async function fetchMinimumSupportedVersion() {
  try {
    // eslint-disable-next-line supabase-guard/require-order, supabase-guard/require-bound -- PK等価の1行取得(maybeSingle=最大1行)
    const { data, error } = await supabase
      .from('app_config')
      .select('config_value')
      .eq('config_key', 'minimum_supported_version')
      .maybeSingle()
    if (error) return null
    const v = data?.config_value
    return v && parseVersion(v) ? v : null
  } catch {
    return null
  }
}
